<template>
  <div class="enterprise-wechat-approval-index details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      style="min-height: 100%"
    >
      <template slot="left">
        <div class="app-main-content">
          <div class="grid-view">
            <div style="display:flex;flex-direction: row; flex: 1;">
              <el-tree
                style="width: 180px"
                highlight-current
                class="custom-category-list section"
                node-key="id"
                :data="leftData"
                :current-node-key="currentNodeKey"
                @node-click="handleSelect"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="app-main-content">
          <div class="tabs-container">
            <!-- 我发起的 -->
            <el-tabs
              v-if="activeMenu === '1'"
              v-model="lookActiveTab"
              style="width: 100%"
              type="card"
              @tab-click="handleClick"
            >
              <el-tab-pane name="lookAll">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_All') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="lookActiveTab === 'lookAll'"
                  :key="detailRefreshId"
                  ref="lookAll"
                  :status="0"
                  type="look"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="lookProcessing">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Processing') }}
                  <el-badge v-if="initiated.processingCount > 0" :value="initiated.processingCount" />
                </span>
                <enterprise-wechat-approval-detail
                  v-if="lookActiveTab === 'lookProcessing'"
                  :key="detailRefreshId"
                  ref="lookProcessing"
                  :status="1"
                  type="look"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="lookApproved">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Approved') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="lookActiveTab === 'lookApproved'"
                  :key="detailRefreshId"
                  ref="lookApproved"
                  :status="2"
                  type="look"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="lookRejected">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Rejected') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="lookActiveTab === 'lookRejected'"
                  :key="detailRefreshId"
                  ref="lookRejected"
                  :status="3"
                  type="look"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="lookCancelled">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Cancelled') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="lookActiveTab === 'lookCancelled'"
                  :key="detailRefreshId"
                  ref="lookCancelled"
                  :status="4"
                  type="look"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
            </el-tabs>
            <!-- 我处理的 -->
            <el-tabs
              v-else
              v-model="approveActiveTab"
              type="card"
              @tab-click="handleClick"
            >
              <el-tab-pane name="approveAll">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_All') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="approveActiveTab === 'approveAll'"
                  :key="detailRefreshId"
                  ref="approveAll"
                  type="approve"
                  :status="0"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="approvePending">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Pending') }}
                  <el-badge v-if="approve.processingCount > 0" :value="approve.processingCount" />
                </span>
                <enterprise-wechat-approval-detail
                  v-if="approveActiveTab === 'approvePending'"
                  :key="detailRefreshId"
                  ref="approvePending"
                  type="approve"
                  :status="1"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="approveApproved">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Approved') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="approveActiveTab === 'approveApproved'"
                  :key="detailRefreshId"
                  ref="approveApproved"
                  type="approve"
                  :status="2"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="approveRejected">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Rejected') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="approveActiveTab === 'approveRejected'"
                  :key="detailRefreshId"
                  ref="approveRejected"
                  type="approve"
                  :status="3"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane name="approveCancelled">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Cancelled') }}
                </span>
                <enterprise-wechat-approval-detail
                  v-if="approveActiveTab === 'approveCancelled'"
                  :key="detailRefreshId"
                  ref="approveCancelled"
                  type="approve"
                  :status="4"
                  :document-config-id="documentConfigId"
                  :template-columns="currentTemplateColumns"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import EnterpriseWechatApprovalDetail from './components/detail'
import { getEnterpriseWechatApprovalTemplates } from '@/api/enterpriseWechatApproval'

export default {
  name: 'EnterpriseWechatApprovalChecklist',
  components: { CargoLeftRightResize, EnterpriseWechatApprovalDetail },
  data() {
    return {
      activeMenu: '1',
      // 默认展示“审批中”/“待我审批”
      lookActiveTab: 'lookProcessing',
      approveActiveTab: 'approvePending',
      initiated: {
        processingCount: 0
      },
      approve: {
        processingCount: 0
      },
      leftData: [],
      currentNodeKey: 1,
      // 原始模板数据（包含表头配置等）
      templates: [],
      documentConfigId: 0,
      // 当前选中的模板对应的动态表头配置
      currentTemplateColumns: [],
      detailRefreshId: 0
    }
  },
  created() {
    console.log('EnterpriseWechatApprovalChecklist created, route:', this.$route && this.$route.fullPath, 'query:', this.$route && this.$route.query)
    // 进入页面时只加载左侧模板树，不主动加载实例列表
    this.loadLeftData().catch(err => {
      console.error('EnterpriseWechatApprovalChecklist loadLeftData error:', err)
    })
  },
  methods: {
    async loadLeftData() {
      console.log('EnterpriseWechatApprovalChecklist loadLeftData start')
      try {
        const { data } = await getEnterpriseWechatApprovalTemplates()
        console.log('EnterpriseWechatApprovalChecklist getEnterpriseWechatApprovalTemplates result:', data)

        // 缓存模板原始数据，便于后续根据模板 ID 获取表头配置
        this.templates = Array.isArray(data) ? data : []

        // 先按 category 分组，再在每个分类下面按【我发起的 / 我处理的】拆分
        const categoryMap = {}
        this.templates.forEach(item => {
          const category = item.category || this.$t('CargoMsg.Cargo_Other') || '其他'
          if (!categoryMap[category]) {
            categoryMap[category] = []
          }
          categoryMap[category].push(item)
        })

        const leftData = []
        const categories = Object.keys(categoryMap)

        categories.forEach((categoryName, catIndex) => {
          const templatesInCategory = categoryMap[categoryName]

          const initiatedChildren = []
          const handledChildren = []

          templatesInCategory.forEach((item, index) => {
            // 我发起的
            initiatedChildren.push({
              id: (catIndex + 1) * 1000 + index,
              code: item.templateId, // 后端字段为 templateId，这里作为节点 code 使用
              label: item.templateName,
              activeMenu: '1'
            })
            // 我处理的
            handledChildren.push({
              id: (catIndex + 1) * 1000 + 500 + index,
              code: item.templateId,
              label: item.templateName,
              activeMenu: '2'
            })
          })

          // 每个 category 作为最上层节点
          leftData.push({
            id: catIndex + 1,
            code: 0,
            label: categoryName,
            activeMenu: '1',
            children: [
              {
                id: (catIndex + 1) * 100 + 1,
                code: 0,
                label: this.$t('CargoMsg.Cargo_IInitiated'),
                activeMenu: '1',
                children: initiatedChildren
              },
              {
                id: (catIndex + 1) * 100 + 2,
                code: 0,
                label: this.$t('CargoMsg.Cargo_IDealWithIt'),
                activeMenu: '2',
                children: handledChildren
              }
            ]
          })
        })

        this.leftData = leftData
        console.log('EnterpriseWechatApprovalChecklist leftData:', this.leftData)
        this.currentNodeKey = 1
      } catch (err) {
        console.error('EnterpriseWechatApprovalChecklist loadLeftData inner error:', err)
      }
    },
    handleSelect(data) {
      // 只有第三层模板节点（有 templateId/code）才触发实例查询
      if (!data.code) {
        // 分类节点或“我发起的/我处理的”节点，只切换当前菜单，不发起接口
        this.activeMenu = data.activeMenu || this.activeMenu
        return
      }

      ++this.detailRefreshId
      this.documentConfigId = data.code
      this.activeMenu = data.activeMenu

      const matched = this.templates.find(item => item.templateId === data.code)
      // 后端 headers: [{ controlId, text }]
      this.currentTemplateColumns = matched && Array.isArray(matched.headers)
        ? matched.headers.map(h => ({
          headerName: h.text,
          field: h.controlId
        }))
        : []

      this.$nextTick(() => {
        if (this.activeMenu === '1') {
          this.lookActiveTab = 'lookProcessing'
        } else if (this.activeMenu === '2') {
          this.approveActiveTab = 'approvePending'
        }
        this.changeTab()
      })
    },
    handleClick() {
      this.changeTab()
    },
    changeTab(documentProcessNo = '') {
      // 没有选中具体模板时，不发起实例查询
      if (!this.documentConfigId) {
        return
      }
      if (this.activeMenu === '1') {
        this.$nextTick(() => {
          this.$refs[this.lookActiveTab].init(documentProcessNo)
        })
      } else if (this.activeMenu === '2') {
        this.$nextTick(() => {
          this.$refs[this.approveActiveTab].init(documentProcessNo)
        })
      }
    },
    reloadCount(total) {
      if (this.activeMenu === '1' && this.lookActiveTab === 'lookProcessing') {
        this.initiated.processingCount = total
      } else if (this.activeMenu === '2' && this.approveActiveTab === 'approvePending') {
        this.approve.processingCount = total
      }
    }
  }
}
</script>

<style lang="scss">
  .enterprise-wechat-approval-index{
    height: 100%;
    margin: 10px;
    .el-tabs{
      width: 100%;
    }
    .app-main-content{
      height: 100%;
    }
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: #009fd6;
      color:#fff;
    }
  }
</style>
